import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import {Form, Formik} from "formik"
import ModalMsg from "../../components/ModalMsg";
import LabelTradotta from "../../components/LabelTradotta";
import NsField from "../../components/fields/NsField.jsx";

export default function ModificaImpostazioneView({
                                                     show,
                                                     setShow,
                                                     modalMsg,
                                                     translate,
                                                     formikRef,
                                                     SignupSchema,
                                                     aggiornaParametro,
                                                     parametro,
                                                     getValore,
                                                     bottoniSx,
                                                     bottoniDx,
                                                 }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Card
                icon={'fas fa-sliders'}
                title={'Modifica Impostazione'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={{
                        id: '',
                        codice: '',
                        descrizione: '',
                        valore: '',
                        canc: ''
                    }}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={aggiornaParametro}
                >
                    {({values, errors, touched, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-6">
                                <NsField
                                    name={"codice"}
                                    label={"Codice:"}
                                    isDisabled={true}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"descrizione"}
                                    label={"Descrizione:"}
                                    as={"textarea"}
                                    isDisabled={true}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            {
                                parametro && parametro.tipo !== 'EM' &&
                                <div className="col-md-12">
                                    <LabelTradotta
                                        htmlFor={"valore"}>{"Valore" + (parametro.required ? "*" : "") + ":"}</LabelTradotta>
                                    {
                                        getValore(values, errors, touched, submitCount)
                                    }
                                </div>
                            }
                            {
                                parametro && parametro.tipo === 'EM' &&
                                <Fragment>
                                    <div className="col-md-6">
                                        <NsField
                                            name={"oggetto"}
                                            label={"Oggetto*:"}
                                            validate={(value) => {
                                                if (value === '') {
                                                    return translate('Questo campo è obbligatorio')
                                                }
                                            }}
                                            formikRef={formikRef}
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            submitCount={submitCount}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <NsField
                                            name={"valore"}
                                            label={"Body*:"}
                                            as={'textarea'}
                                            showErrorMessage={false}
                                            formikRef={formikRef}
                                            values={values}
                                            errors={errors}
                                            touched={touched}
                                            submitCount={submitCount}
                                        />
                                    </div>
                                </Fragment>
                            }
                        </Form>
                    )}
                </Formik>
            </Card>
        </div>
    );
}